export * from "./atoms";
export * from "./molecules";
export * from "./organisms";
export * from "./messages";

import { ProjectAtoms } from "./atoms";
import { ProjectMessages } from "./messages";
import { ProjectMolecules } from "./molecules";
import { ProjectOrganisms } from "./organisms";

export const ProjectComponents = [
  ...ProjectAtoms,
  ...ProjectMolecules,
  ...ProjectOrganisms,
  ...ProjectMessages,
];